import * as React from "react";
import { useId } from "@fluentui/react-hooks";
import {
  getTheme,
  mergeStyleSets,
  FontWeights,
  Modal,
  IIconProps,
} from "@fluentui/react";
import { IconButton, IButtonStyles } from "@fluentui/react/lib/Button";

export const CustomModal = (props: IImageModalProps) => {
  const { isModalOpen, onDismiss, content, title, subTitle, minWidth, minHeight } =
    props;

  const cancelIcon: IIconProps = { iconName: "Cancel" };

  const theme = getTheme();
  const contentStyles = mergeStyleSets({
    container: {
      display: "flex",
      flexFlow: "column nowrap",
      alignItems: "stretch",
      width: minWidth ? minWidth : 700,
      maxWidth: "90vw",
    },
    header: [
      theme.fonts.xLargePlus,
      {
        flex: "1 1 auto",
        borderTop: `4px solid ${theme.palette.themePrimary}`,
        color: theme.palette.neutralPrimary,
        display: "flex",
        alignItems: "center",
        fontWeight: FontWeights.semibold,
        padding: "12px 12px 14px 24px",
      },
    ],
    heading: {
      color: theme.palette.themePrimary,
      fontWeight: FontWeights.semibold,
      fontSize: "inherit",
      margin: "0",
    },
    subheader: {
      paddingLeft: "24px",
      textAlign: "center",
    },
    subheading: {
      color: theme.palette.green,
      fontWeight: FontWeights.semibold,
      fontSize: "inherit",
      margin: "0",
    },
    body: {
      flex: "4 4 auto",
      padding: "0 24px 24px 24px",
      overflowX: "auto",
      overflowY: "auto",
      minHeight: minHeight ? minHeight : 200,
      maxHeight: 500,
      minWidth: minWidth ? minWidth : 650,
      selectors: {
        p: { margin: "14px 0" },
        "p:first-child": { marginTop: 0 },
        "p:last-child": { marginBottom: 0 },
      },
    },
  });
  const iconButtonStyles: Partial<IButtonStyles> = {
    root: {
      color: theme.palette.neutralPrimary,
      marginLeft: "auto",
      marginTop: "4px",
      marginRight: "2px",
    },
    rootHovered: {
      color: theme.palette.neutralDark,
    },
  };

  // Use useId() to ensure that the IDs are unique on the page.
  // (It's also okay to use plain strings and manually ensure uniqueness.)
  const titleId = useId("title");

  return (
    <div>
      <Modal
        titleAriaId={titleId}
        isOpen={isModalOpen}
        onDismiss={onDismiss}
        isBlocking={true}
        containerClassName={contentStyles.container}
        dragOptions={undefined}
      >
        <div className={contentStyles.header}>
          {title && (
            <h2 className={contentStyles.heading} id={titleId}>
              {title}
            </h2>
          )}
          <IconButton
            styles={iconButtonStyles}
            iconProps={cancelIcon}
            ariaLabel="Close popup modal"
            onClick={onDismiss}
          />
        </div>
        {subTitle && (
          <div className={contentStyles.subheader}>
            <h3 className={contentStyles.subheading}>{subTitle}</h3>
          </div>
        )}
        <div className={contentStyles.body}>{content}</div>
      </Modal>
    </div>
  );
};
